
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default() {
  return {
    select: {
      minWidth: 200,
      background: '#80bfdc',  
      color: 'white',
      fontWeight: 600,
      borderStyle: 'none',
      borderWidth: 2,
      borderRadius: 12,
      paddingLeft: 24,
      paddingTop: 14,
      paddingBottom: 15,
      boxShadow: '0px 5px 8px -3px rgba(0,0,0,0.14)',
      "&:focus": {
        borderRadius: 12,    
         background: '#80bfdc', 
        color: 'white',
        fontWeight: 600,
        borderStyle: 'none',
        borderWidth: 2,
        paddingLeft: 24,
        paddingTop: 14,
        paddingBottom: 15,
        boxShadow: '0px 5px 8px -3px rgba(0,0,0,0.14)',
      }
    },
    icon: {
      color: 'white',
      right: 12,
      position: 'absolute',
      userSelect: 'none',
      pointerEvents: 'none'
    },
    paper: {
      borderRadius: 12,
      marginTop: 8
    },
    list: {
      paddingTop: 0,
      paddingBottom: 0,
      fontWeight: 600,
      color: '#80bfdc',
      background: 'white',  
      "& li": {      
        paddingTop: 12,
        paddingBottom: 12,
        fontWeight: 600,
        color: '#022c31',
        background: 'white',  
      },
      "& li:hover": {
        color: 'black',
        background: '#b5f6fd',  
        fontWeight: 600,
      },
      "& li.Mui-selected": {
        color: 'white',
        background: '#80bfdc', 
        fontWeight: 600,
      },
      "& li.Mui-selected:hover": {
        color: 'white',
        background: '#06b3c6', 
        fontWeight: 600, 
      }
    }
  };
};

exports["default"] = _default;